<template>
  <div class="mb-4">
    <ul class="nav nav-pills nav-justified">
      <li class="nav-item waves-effect waves-light">
        <router-link
          class="nav-link"
          :class="{ 
            active: seccion == 'fichas'
          }"
          :to="{ name: 'fichasHotspot' }"
        >
          Fichas
        </router-link>
      </li>
      <li class="nav-item waves-effect waves-light">
        <router-link
          :to="{ name: 'fichasTiposHotspot' }"
          class="nav-link"
          :class="{ 
            active: seccion == 'tipo-fichas'
          }"
        >
          Tipo de fichas
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CmpSecciones',
  props: ['seccion']
}
</script>
<style scoped>
.no-cursor{
  cursor: default;
}
</style>